import  request  from '../../Interceptor/request.js'

//户号判断
export function houseIf(data) {
    return request({
        url: '/devInstance/list',
        method: 'get',
        params:data
    })
}

//月查询
export function getSms(data) {
    return request({
        url: '/sms/check',
        method: 'get',
        params:data
    })
}

//验证码
export function getSend(data) {
    return request({
        url: '/sms/send',
        method: 'get',
        params:data
    })
}

